<template lang="pug">
  div
    .sum-whb-wrapper-window(v-if="sums && !sums.showDetails && !loadingSumWhb")
      .month-whb-window
        b créditos
        b débitos
        b quitação
        span.hours-whb {{ sanitazeHours(sums.monthWindow.totalCurrentAcumlated) }}
        span.hours-whb-n {{ sanitazeHours(sums.monthWindow.totalCurrentCompensated) }}
        span.hours-whb-q {{ sanitazeHours(sums.monthWindow.compensatedDue) }}

      .overal-history-container
        h3 compensação banco de horas

        .whbo-details-compensation-table-item-short(style="border-bottom: 2px solid #8d8c8c;")
          strong mês de referência
          strong mês vencimento
          strong saldo anterior
          strong saldo acumulado

        .whbo-details-compensation-table-item-short(v-for="item in sums.overAllWindow.details")
          span {{ item.endDate | monthYear }}
          span {{ item.dueDate | monthYear }}
          span {{ sanitazeHours(item.lastMonthBalance) }}
          span {{ sanitazeHours(item.balance) }}

        .whbo-details-compensation-table-item-short(style="border-top: 2px solid #8d8c8c; padding-top: 5px;")
          b total:
          span
          span(v-bind:class="{\
            'hours-whb-n': isPositive(sums.overAllWindow.totalWindow), \
            'hours-whb': !isPositive(sums.overAllWindow.totalWindow)}")
            | {{ sanitazeHours(sums.overAllWindow.totalWindow) }}
          span(v-bind:class="{\
            'hours-whb-n': isPositive(sums.overAllWindow.totalBalance), \
            'hours-whb': !isPositive(sums.overAllWindow.totalBalance)}")
            | {{ sanitazeHours(sums.overAllWindow.totalBalance) }}

    .sum-whb-wrapper(v-if="sums && sums.showDetails && !loadingSumWhb")
      .block
        span total banco de horas mensal
        totalPeriod(:whboTotal="sums.monthGeneral[0]", :showSimbols="true")

      .block
        span total banco de horas até o momento
        totalPeriod(:whboTotal="sums.overAllGeneral[0]", :showSimbols="true")

      accordion.accordion
        template(slot="heading")
          .to-click.fs-17 mostrar detalhes

        .accordion-content
          .core
            h4 banco de horas mensal
            .core-detalhes-momento
              div
                .apontamentos-title horas acumuladas
                hr
                totalPeriod(:whboTotal="sums.monthPositive[0]")

              div
                .apontamentos-title horas compensadas
                hr
                totalPeriod(:whboTotal="sums.monthNegative[0]")

          .core
            h4 banco de horas até o momento
            .core-detalhes-mensal
              div
                .apontamentos-title horas acumuladas
                hr
                totalPeriod(:whboTotal="sums.overAllPositive[0]")

              div
                .apontamentos-title horas compensadas
                hr
                totalPeriod(:whboTotal="sums.overAllNegative[0]")

    .sum-whb-wrapper-window(v-if="loadingSumWhb")
      .month-whb-window
        svg(v-for="i in 3" viewBox="0 0 100 12" preserveAspectRatio="xMidYMid meet")
          rect(x="35" y="0" width="30" height="4" style="fill: #e0e0e0;")
          rect(x="0" y="6" width="100" height="7" style="fill: #e0e0e0;")

      .overal-history-container
        svg(viewBox="0 0 100 6" preserveAspectRatio="xMidYMid meet")
          rect(x="40" y="2" width="20" height="2" style="fill: #e0e0e0;")

      .whbo-details-compensation-table-item-short
        svg(viewBox="0 0 100 4" preserveAspectRatio="xMidYMid meet")
          rect(x="0" y="0" width="18" height="1" style="fill: #e0e0e0;")
          rect(x="25" y="0" width="18" height="1" style="fill: #e0e0e0;")
          rect(x="50" y="0" width="18" height="1" style="fill: #e0e0e0;")
          rect(x="75" y="0" width="18" height="1" style="fill: #e0e0e0;")

</template>

<script>
import Accordion from 'src/common/VueAccordion'
import TotalPeriod from './TotalPeriod'
import moment from 'moment'

export default {
  props: {
    sumWhb: {type: Object, required: true},
    loadingSumWhb: {type: Boolean, required: true}
  },
  computed: {
    sums () {
      const { overal, monthly } = this.sumWhb

      if (!overal || !monthly) { return }

      const pos = ['extra_time_50_tot', 'extra_time_100_tot', 'extra_time_special_tot', 'extra_time_50_not_tot',
        'extra_time_100_not_tot', 'extra_time_special_not_tot']
      const neg = ['absence_hours', 'delay_time', 'early_exit', 'lunch_penalty']
      const gen = ['general_extra_time', 'general_delay', 'all_times']

      return {
        monthPositive: [{
          extra_time_50_tot: monthly['extra_time_50_tot'],
          extra_time_100_tot: monthly['extra_time_100_tot'],
          extra_time_special_tot: monthly['extra_time_special_tot'],
          extra_time_50_not_tot: monthly['extra_time_50_not_tot'],
          extra_time_100_not_tot: monthly['extra_time_100_not_tot'],
          extra_time_special_not_tot: monthly['extra_time_special_not_tot'],
          titleList: pos,
          titles: monthly['titles']
        }],
        monthNegative: [{
          absence_hours: monthly['absence_hours'],
          delay_time: monthly['delay_time'],
          early_exit: monthly['early_exit'],
          lunch_penalty: monthly['lunch_penalty'],
          titleList: neg,
          titles: monthly['titles']
        }],
        monthGeneral: [{
          general_extra_time: monthly['general_extra_time'],
          general_delay: monthly['general_delay'],
          all_times: monthly['all_times'],
          titleList: gen,
          titles: monthly['titles']
        }],
        overAllPositive: [{
          extra_time_50_tot: overal['extra_time_50_tot'],
          extra_time_100_tot: overal['extra_time_100_tot'],
          extra_time_special_tot: overal['extra_time_special_tot'],
          extra_time_50_not_tot: overal['extra_time_50_not_tot'],
          extra_time_100_not_tot: overal['extra_time_100_not_tot'],
          extra_time_special_not_tot: overal['extra_time_special_not_tot'],
          titleList: pos,
          titles: overal['titles']
        }],
        overAllNegative: [{
          absence_hours: overal['absence_hours'],
          delay_time: overal['delay_time'],
          early_exit: overal['early_exit'],
          lunch_penalty: overal['lunch_penalty'],
          titleList: neg,
          titles: overal['titles']
        }],
        overAllGeneral: [{
          general_extra_time: overal['general_extra_time'],
          general_delay: overal['general_delay'],
          all_times: overal['all_times'],
          titleList: gen,
          titles: overal['titles']
        }],
        overAllWindow: overal.window,
        monthWindow: monthly.window,
        showDetails: monthly.showDetails
      }
    }
  },
  methods: {
    isPositive (value) {
      if (value) {
        return value.indexOf('-') > -1
      } else {
        return false
      }
    },
    sanitazeHours (value) {
      return value === '-00:00' ? '00:00' : value
    }
  },
  components: {TotalPeriod, Accordion},
  filters: {
    monthYear (date) {
      return moment(date).format('MM.YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
.sum-whb-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-bottom: 20px;

  &:first-child h2 {
    grid-column: 1/3;
    text-align: center;
  }

  .block {
    display: grid;
    align-items: center;
    text-align: center;
  }

  .accordion {
    grid-column: 1/3;

    .accordion-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;

      .core {
        justify-content: center;
        justify-items: center;
        text-align: center;

        .core-detalhes-momento {
          grid-area: detalhes-momento;
          display: grid;
          grid-template-columns: 1fr 1fr;
          justify-content: center;
          justify-items: center;
          grid-column-gap: 25px;
        }
        .core-detalhes-mensal {
          grid-area: detalhes-mensal;
          display: grid;
          grid-template-columns: 1fr 1fr;
          justify-content: center;
          justify-items: center;
          grid-column-gap: 25px;
        }
      }
    }
  }
}

.sum-whb-wrapper-window {

  .month-whb-window {
    display: grid;
    width: 100%;
    justify-items: center;
    grid-gap: 5px;
    grid-template-columns: 2fr 2fr 2fr;

    b {
      text-align: center;
      padding-top: 15px;
    }
    label {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: .1fr .1fr;
      text-align: center;
    }
  }

  .overal-history-container {
    display: grid;
    align-items: center;
    text-align: center;
    padding-bottom: 1%;

    .whbo-details-compensation-table-item-short {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: auto;
      grid-column-gap: 5px;
      grid-auto-flow: column;
    }
  }
}
span.hours-whb, span.hours-whb-n, span.hours-whb-q {
  width: 100%;
  height: 20px;
  text-align: center;
  color: whitesmoke;
  padding-top: 2px;
  padding-bottom: 2px;
}
span.hours-whb { background-color: var(--color-success); }
span.hours-whb-n { background-color: var(--color-danger); }
span.hours-whb-q { background-color: #959595; }
</style>
